import * as angular from "angular";
import {IController} from "angular";

export class DashboardsListComponent implements IController {

  favoriteDashboardId: string;
  currentSelectedDashboardId: string;
  onClose: Function;
  onToggleCreateDashboard: Function;
  onSelectDashboard: Function;
  onSetDashboardAsFavorite: Function;

  public query: string;
  public visibility: any;
  public dashboardsRef: any;
  public infiniteScroll: any;
  public loadLimit: number;

  constructor(private $dashboards, private $infiniteScroll, private $log) {
  }

  $onInit() {
    this.loadLimit = 20;
    this.dashboardsRef = this.$dashboards();
    this.dashboardsRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.dashboardsRef, this.loadLimit, {getFullData: true});
  };

  onQueryChange(query) {
    this.query = query;
    this._reload();
  }

  onChangeVisibility(visibility) {
    this.visibility = visibility;
    this._reload();
  }


  private _reload() {
    this.dashboardsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      searchTerm: this.query,
      limit: this.loadLimit,
      visibility: this.visibility
    }
  }

}

angular
  .module('bringoz.admin.dashboards')
  .component('dashboardsList', {
    bindings: {
      favoriteDashboardId: '<?',
      currentSelectedDashboardId: '<?',
      onClose: '&',
      onToggleCreateDashboard: '&',
      onSelectDashboard: '&',
      onSetDashboardAsFavorite: '&'
    },
    template: require('./dashboards-list.html').default,
    controller: DashboardsListComponent
  });
